// extracted by mini-css-extract-plugin
export default {"loaderBackground":"GlobalLoader_loaderBackground__PU8rm","spinner":"GlobalLoader_spinner__-IDf4"};